<script setup lang="ts">
import { computed } from 'vue'

import { TextInput } from '@collector/shared-ui'
import { nullCoalesce } from '@collector/shared-utils'
import type { Stat } from '@collector/sportsapi-types'

export type Props = {
  dirty?: boolean
  disabled?: boolean
  size?: 'sm' | 'md'
  formatSuffix?: string
  maxlength?: number
  numeric?: boolean
  pattern?: RegExp
}

const props = withDefaults(defineProps<Props>(), { size: 'md' })

// emits
defineEmits<{
  blur: [{ event: Event; value: string }]
}>()

// state
const stat = defineModel<Stat>({ required: true })

// computed
const inputClass = computed(() => {
  const result = ['text-center']

  if (props.size === 'md') result.push('w-14')
  else if (props.size === 'sm') result.push('w-8 h-6!')

  if (props.dirty) result.push('font-bold')
  else result.push('font-normal')

  return result.join(' ')
})

// methods
function normalizeDecimal(
  value: string | number | null,
): string | number | null {
  if (value === null || value === '') {
    return value
  }

  return String(value).replace(',', '.')
}
</script>

<template>
  <div>
    <div
      v-if="disabled"
      class="p-1 whitespace-nowrap"
    >
      {{ stat.value }} {{ formatSuffix }}
    </div>
    <TextInput
      v-else
      :modelValue="stat.value"
      :inputClass
      :maxlength
      :variant="dirty ? 'heavy' : 'light'"
      :disabled
      :numeric
      placeholder="-"
      :pattern
      @blur="$emit('blur', $event)"
      @update:modelValue="
        stat = {
          ...stat,
          value: normalizeDecimal(nullCoalesce($event, null)),
        }
      "
    />
  </div>
</template>
